import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[thAutoFocus]' })
export class AutoFocusDirective implements AfterContentInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterContentInit() {
    if (this.elementRef.nativeElement instanceof HTMLElement) {
      this.elementRef.nativeElement.focus();
    }
  }
}
